module.exports = __webpack_public_path__ + "img/ic_notification_star.df72238a.svg";